
      // Only initialize GA4 in production builds with a valid tracking ID
      if (import.meta.env.PROD && import.meta.env.VITE_GA_TRACKING_ID) {
        // Load gtag.js
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', import.meta.env.VITE_GA_TRACKING_ID);
        
        // Inject the script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + import.meta.env.VITE_GA_TRACKING_ID;
        document.head.appendChild(script);
      }
    